import React, { Component } from "react";

import { connect } from "react-redux";
import { hideRightSidebar, changeMainTheme } from "../../store/actions";

//SimpleBar
import SimpleBar from "simplebar-react";

import { Link } from "react-router-dom";

import "./rightbar.scss";
//Import images
import layout1 from "../../assets/images/layouts/layout-1.jpg";
import layout2 from "../../assets/images/layouts/layout-2.jpg";

//Component
import LanguageDropdown from "../CommonForBoth/TopbarDropdown/LanguageDropdown";

class RightSidebar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      mainTheme: this.props.mainTheme,
    };
    this.hideRightbar = this.hideRightbar.bind(this);
    this.changeMainTheme = this.changeMainTheme.bind(this);
  }

  /**
   * Hides the right sidebar
   */
  hideRightbar(e) {
    e.preventDefault();
    this.props.hideRightSidebar();
  }

  componentDidUpdate(prevProps) {
    if (prevProps !== this.props) {
      this.setState({
        mainTheme: this.props.mainTheme,
      });
    }
  }

  // change topbar theme
  changeMainTheme(theme) {
    console.log(theme);
    this.props.changeMainTheme(theme);
  }

  render() {
    return (
      <React.Fragment>
        <div className="right-bar">
          <SimpleBar style={{ height: "900px" }}>
            <div data-simplebar className="h-100">
              <div className="rightbar-title px-3 py-4">
                <Link
                  to="#"
                  onClick={this.hideRightbar}
                  className="right-bar-toggle float-right"
                >
                  <i className="mdi mdi-close noti-icon"></i>
                </Link>
                <h5 className="m-0">Settings</h5>
              </div>

              <hr className="my-0" />
              <div className="mt-3">
                <h6 className="text-center">Language</h6>
                <div style={{ marginLeft: "5rem" }}>
                  <LanguageDropdown />
                </div>
              </div>
              <div className="p-4">
                <h6 className="text-center">Choose Layouts</h6>

                <div className="mb-2">
                  <Link to="#" onClick={() => this.changeMainTheme("light")}>
                    <img
                      src={layout1}
                      className="img-fluid img-thumbnail"
                      alt=""
                    />
                  </Link>
                </div>

                <div className="mb-2">
                  <Link to="#" onClick={() => this.changeMainTheme("dark")}>
                    <img
                      src={layout2}
                      className="img-fluid img-thumbnail"
                      alt=""
                    />
                  </Link>
                </div>
              </div>
            </div>
          </SimpleBar>
        </div>
        <div className="rightbar-overlay"></div>
      </React.Fragment>
    );
  }
}

const mapStatetoProps = (state) => {
  return { ...state.Layout };
};

export default connect(mapStatetoProps, {
  hideRightSidebar,
  changeMainTheme,
})(RightSidebar);
